<p>This Investigation is a <b>Dead End!</b>. You didn't receive any new information or evidence.</p>
